var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClockCheckColored = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "clock-check"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon",
  d: "M1.75 3.20866L2.91667 2.04199M12.25 3.20866L11.0833 2.04199M5.25 7.29199L6.41667 8.45866L8.75 6.12533M11.6667 7.29199C11.6667 9.86932 9.57733 11.9587 7 11.9587C4.42267 11.9587 2.33333 9.86932 2.33333 7.29199C2.33333 4.71466 4.42267 2.62533 7 2.62533C9.57733 2.62533 11.6667 4.71466 11.6667 7.29199Z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgClockCheckColored);
export default ForwardRef;